import moment from 'moment-timezone';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

type Props = {
  currentTimeZone: string;
  onChange: (timezone: string) => void;
};

const TimeZoneSelector: FC<Props> = ({ currentTimeZone, onChange }) => {
  const { t } = useTranslation();

  const options = moment.tz.names().map(zone => {
    return {
      value: zone,
      label: '(UTC' + moment().tz(zone).format('Z') + ') ' + zone,
      // " (" +
      // moment().tz(zone).format("hh:mm a ") +
      // ")"
    };
  });

  return (
    <div className="tw-px-2 tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-6 tw-flex">
      <div>
        <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
          {t('VisibilityManagerEdit/key1')}
        </div>
        <div className="tw-self-stretch tw-text-gray-900 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('VisibilityManagerEdit/key2')}</div>
      </div>
      <div className="md:tw-max-w-[357px] tw-w-full tw-justify-start tw-items-start tw-gap-2 tw-flex tw-flex-col tw-mb-6">
        <ReactSelect
          className="tw-w-full"
          options={options}
          maxMenuHeight={120}
          value={
            currentTimeZone
              ? {
                  value: moment.tz.names().find(item => item === currentTimeZone),
                  label: '(UTC' + moment().tz(currentTimeZone).format('Z') + ') ' + currentTimeZone,
                }
              : {
                  value: moment.tz.names().find(item => item === moment.tz.guess()),
                  label: '(UTC' + moment().tz(moment.tz.guess()).format('Z') + ') ' + moment.tz.guess(),
                  // " (" +
                  // moment().tz(moment.tz.guess()).format("hh:mm a ") +
                  // ")"
                }
          }
          onChange={e => {
            onChange(e?.value as string);
          }}
        />
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(TimeZoneSelector);
